export enum ImportProtocolStatus {
  Pending = "Pending",
  Success = "Success",
  Error = "Error",
  Warning = "Warning",
}
